import { BaseEntity } from '../../models';
import { Usuario } from '../usuario';

export class Nota implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    createdAt: Date;
    idUsuarioCreated: number;
    usuarioCreated?: Usuario;
    updatedAt: Date;
    idUsuarioUpdated: number;
    usuarioUpdated?: Usuario;
    texto: string;

    // Referências
    idLead: number;
    idCliente: number;
    idNegocio: number;
    idTituloReceber: number;

    constructor(idEmpresa: number, texto: string = null) {
        this.idEmpresa = idEmpresa;
        this.texto = texto;
    }
}
